<template>
  <LandingSection
    class="scenarios"
    title="应用场景"
    desc="为各类应用与服务，提供即插即用的 AI 数字人视频引擎"
    header-spacing="40px"
  >
    <ImageTextCarousel :infos="infos">
      <template #button>
        <ArrowBtn
          class="scenarios__btn"
          variant="purple-common"
          text="立即咨询"
          @click="$emit('consultClick')"
        ></ArrowBtn>
      </template>
    </ImageTextCarousel>
  </LandingSection>
</template>

<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import { getFeUrl } from '@/utils/url';
import ImageTextCarousel from '~/design/widgets/image-text-carousel/index.vue';
import LandingSection from '~/design/widgets/landing-section/cn-template.vue';

const infos = [
  {
    title: '数字化营销提效',
    desc: '为商家和品牌提供批量视频生成能力，提升营销内容产出效率与传播表现力。',
    list: [
      {
        label: '虚拟代言人运营：',
        content: '结合数字人定制，打造专属品牌角色，实现品牌 IP 常态化运营',
      },
      {
        label: '电商及社媒内容运营：',
        content: '将商品海报、营销文案自动转化为短视频，提高营销内容生成效率',
      },
      {
        label: '本地化传播：',
        content: '支持多族裔形象、多语种视频生成，适配不同国家本地化推广需要',
      },
    ],
    url: getFeUrl(
      '/youyan-platform/api-intro/scenarios/scene-1.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: '企业培训与知识平台升级',
    desc: '提供标准化、高效率的视频内容生成能力，加速培训课程制作与知识沉淀。',
    list: [
      {
        label: '标准化课程生成：',
        content:
          '将视频生成能力集成至现有培训系统，自动将 PPT、讲稿、操作手册等内容转化为可视化讲解视频',
      },
      {
        label: '知识库视频化改造：',
        content: '支持将企业碎片化知识自动转化为结构化培训视频，构建可检索、可复用的知识库',
      },
    ],
    url: getFeUrl(
      '/youyan-platform/api-intro/scenarios/scene-2.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: '智慧课堂升级',
    desc: '嵌入标准化视频生成能力，提升课程交付效率与教学内容规模化供给能力。',
    list: [
      {
        label: 'AI 自动制课：',
        content: '系统自动将课本教材转化为数字人教学视频',
      },
      {
        label: 'AI 助教：',
        content:
          '集成在学习平台、APP、学习机或官网中，进行实时答疑、知识点讲解、口语陪练、招生咨询',
      },
      {
        label: '心理辅导与陪伴：',
        content: '作为 AI 心理辅导员，提供个性化心理咨询和陪伴服务',
      },
    ],
    url: getFeUrl(
      '/youyan-platform/api-intro/scenarios/scene-3.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: 'AI工具与创作类应用升级',
    desc: '集成至各类 AI 写作、内容生成工具中，为用户提供一键脚本转视频功能。',
    list: [
      {
        label: 'AI 内容创作工具增强：',
        content: '在 AIGC 内容平台中，加入数字人视频输出能力，让生成结果具备更强的传播力与交互感',
      },
      {
        label: 'PPT自动讲解视频生成：',
        content: '帮助办公类工具实现 PPT 一键转讲解视频，用于演示录制、线上汇报等场景',
      },
    ],
    url: getFeUrl(
      '/youyan-platform/api-intro/scenarios/scene-4.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: '金融/政务/医疗行业落地',
    desc: '将标准业务内容自动转化为视频形式，提升信息传达效率与服务体验。',
    list: [
      {
        label: '政务导办：',
        content: '将政策解读、办事流程转化为标准化数字人讲解视频，广泛部署于政务大屏、官网及App',
      },
      {
        label: '金融讲解：',
        content: '支持私有化部署，自动生成标准化产品介绍、流程说明视频，满足数据安全与合规要求',
      },
      {
        label: '医疗科普与推介：',
        content: '将产品说明、术前指导等专业内容转化为数字人讲解视频，提升患者理解力与传播效率',
      },
    ],
    url: getFeUrl(
      '/youyan-platform/api-intro/scenarios/scene-5.jpg?x-oss-process=image/format,webp',
    ),
  },
];
</script>

<style lang="scss" scoped>
.scenarios {
  border-bottom: 1px solid var(--x-back-4);
}
.scenarios__btn {
  position: absolute;
  display: inline-flex;
  align-self: flex-start;
  transition: none;
  left: clamp(32px, calc(32px + (48 - 32) * ((100vw - 1600px) / (1920 - 1600))), 48px);
  bottom: clamp(48px, calc(48px + (80 - 48) * ((100vw - 1600px) / (1920 - 1600))), 80px);
}
</style>
